define('views/modules/member/group/edit/group-edit-panel',[
    // Libs
    'underscore', 'utils',
    // collections
    'collections/member/groups',
    //models
    'models/member/group',
    // views
    'views/parts/panel/base-panel',
    'views/modules/member/group/edit/group-edit-content',
], function(
    // Libs
    _, U,
    // collections
    CGroups,
    //models
    MGroup,
    // views
    VBasePanel,
    VGroupEditContent
) {

    var VGroupEditPanel = VBasePanel.extend({
        header: {
          title: "supervisor:group-edit-title",
          subtitle: "supervisor:group-edit-subtitle",
        },
        buttons: { back: 'close', },
        content: { edit: VGroupEditContent, },
        tabs: [{ id: 'edit', active: true }],

        initialize: function(opt) {
            this.selectedGroup = opt.selectedGroup;
            this.groupList = opt.groupList;
            //this.collection = new CGroups(null, { tree: false, tree_only: true, removeExpired: false });
            this.collection = new CGroups(null, { root_only: true, tree: true, tree_only: true, removeExpired: false });

        },

        render: function() {
            VGroupEditPanel.__super__.render.apply(this, arguments);
            this.collection.fetch();

            this.showContent('edit', { model: this.model });

            if (this.view.edit)
            {
              this.view.edit.selectedGroup = this.selectedGroup;
            }

            return this;
        },

        setModel: function(model) {
            if (!model) return;

            this.model = model;

            if (this.model.isNew()) {
              this.model.set("name", "");
            }
            this.options.model = model;

            return this;
        },

        getContentViewOptions: function(options) {
            return _.extend({}, options, {
              model: this.model,
              collection: this.collection,
              selectedGroup: this.selectedGroup,
            });
        },

        onClosePanel: function() {
            this.view.edit = null;
        },

        onGroupEdit: function(model) {
          this.groupList.addGroup(model);
        }

    });

    return VGroupEditPanel;
});

